import React from 'react'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import Modal from './Modal'
import Headline from '../a/Headline'

export default class NoticeModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      commentNote: props.commentNote || '',
    }
  }

  render() {
    const {commentNote} = this.state

    const {lastname, firstname, id, confirmCallback, trigger} = this.props

    const commentReject = commentNote.length < 1

    return (
      <Modal
        id={id}
        trigger={trigger}
        confirmCallback={() => confirmCallback(commentNote)}
        confirmButtonDisabled={commentReject}
        confirmText={i18n.t('save_notice')}
        hasCloseButton
      >
        <div className="noticeModal">
          <Headline modifier="article" importance={2} text={i18n.t('azubi_notice_title')} />
          <span className="noticeModal__lengthHint">{`zu ${lastname}, ${firstname}`}</span>
        </div>
        <textarea
          className="noticeModal__textbox"
          value={commentNote}
          onChange={elem =>
            this.setState({
              commentNote: elem.target.value,
            })
          }
          placeholder={i18n.t('azubi_notice_modal_text')}
        />
      </Modal>
    )
  }
}

NoticeModal.propTypes = {
  id: PropTypes.string,
  trigger: PropTypes.node,
  commentNote: PropTypes.string,
  confirmCallback: PropTypes.func.isRequired,
  lastname: PropTypes.string,
  firstname: PropTypes.string,
}
